<template>
  <div class="phone">
    <div>
      <p class="compliance">
        This study is conducted using technologies and an online platform provided by MoreBetter
        Ltd. Message and data rates may apply. Messages will contain links to questionaires for this
        study. Message frequency varies. Text STOP to opt out. For support please contact
        <a href="mailto:support@morebetter.ltd">support@morebetter.ltd</a> or visit our
        <a href="https://morebetter.ltd/contact-us">contact page</a>. Our privacy policy can be
        found at <a href="https://morebetter.ltd/privacy">https://morebetter.ltd/privacy</a>. Mobile
        carriers are not liable for delayed or undelivered messages.
      </p>
    </div>
    <div>
      <div v-html="phoneText"></div>
      <VuePhoneNumberInput
        default-country-code="US"
        v-model="phoneInput"
        @update="onUpdatePhone"
        no-validator-state
      />
    </div>
    <div class="buttons">
      <v-btn class="submit-button" color="primary" :disabled="!isValid" @click="onSubmit">
        {{ submitButton }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VuePhoneNumberInput from 'vue-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  name: 'Phone',
  components: {
    VuePhoneNumberInput,
  },
  computed: {
    ...mapState(['phoneText', 'submitButton']),

    // Read exception area codes from global
    exceptionAreaCodes() {
      return this.$phoneExceptionAreaCodes || [];
    },
  },
  data() {
    return {
      phoneInput: '',
      phoneNumber: '',
      isValid: false,
    };
  },
  methods: {
    // Check if phone number has exception area code
    hasExceptionAreaCode(formattedNumber) {
      if (!formattedNumber || this.exceptionAreaCodes.length === 0) {
        return false;
      }

      try {
        const phoneNumber = parsePhoneNumber(formattedNumber, 'US');
        if (phoneNumber && phoneNumber.nationalNumber && phoneNumber.nationalNumber.length >= 3) {
          const areaCode = phoneNumber.nationalNumber.substring(0, 3);
          return this.exceptionAreaCodes.includes(areaCode);
        }
        return false;
      } catch (e) {
        return false;
      }
    },

    onUpdatePhone(info) {
      // Check basic format requirements even for exceptions
      const isProperlyFormatted = info.formattedNumber && info.formattedNumber.replace(/\D/g, '').length >= 10;
      const isException = this.hasExceptionAreaCode(info.formattedNumber);

      // Accept if library says valid OR if properly formatted AND in exception list
      this.isValid = info.isValid || (isProperlyFormatted && isException);
      this.phoneNumber = info.formattedNumber;

      // Log for debugging in development only
      if (isException && !info.isValid && process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log(`[Phone] Exception applied for ${info.formattedNumber}`);
      }
    },

    onSubmit() {
      this.$emit('phone', this.phoneNumber);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_variables.scss';

.phone {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .compliance {
    font-size: 12px;
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
    margin-top: 1rem;
  }
}

@media (min-width: $breakpoint-tablet) {
  .phone {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
